import { cn } from "@/lib/utils";

const CHIP = {
  LIVE: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  PAPER: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  ARMED: "bg-amber-500/15 text-amber-400 border-amber-500/30 animate-pulse",
  DISARMED: "bg-slate-700/30 text-slate-400 border-slate-700/50",
  PENDING: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  WAITING: "bg-yellow-500/15 text-yellow-300 border-yellow-500/30",
  IN_INITIAL_TRADE: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  IN_REVERSAL: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/30",
  TRADED: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  DONE: "bg-slate-800 text-slate-300 border-slate-700",
  SKIPPED: "bg-zinc-800/80 text-zinc-400 border-zinc-700/60",
  OK: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  WARNING: "bg-amber-500/15 text-amber-400 border-amber-500/40 animate-pulse",
  TRIGGERED: "bg-rose-500/20 text-rose-400 border-rose-500/40",
  LONG: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  SHORT: "bg-rose-500/15 text-rose-400 border-rose-500/30",
  NONE: "bg-slate-800 text-slate-400 border-slate-700",
  ON: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  OFF: "bg-slate-800 text-slate-400 border-slate-700",
};

export function Chip({ status, label, testid, className }) {
  return (
    <span data-testid={testid} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] whitespace-nowrap", CHIP[status] || CHIP.NONE, className)}>
      {label || String(status).replaceAll("_", " ")}
    </span>
  );
}

export function Panel({ title, right, children, testid, className }) {
  return (
    <section data-testid={testid} className={cn("panel-lux relative rounded-xl border border-white/[0.06] p-4 sm:p-6 backdrop-blur-md transition-colors duration-200 hover:border-white/[0.1] fade-up", className)}>
      {(title || right) && (
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          {title && <h2 className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#E2C77E]"><span className="h-1 w-1 rounded-full bg-[#D4AF37]" />{title}</h2>}
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function Kpi({ label, value, className, testid, sub }) {
  return (
    <div className="rounded-lg border border-white/[0.05] bg-[#0A0E16]/80 px-4 py-3.5 shadow-inner transition-colors duration-150 hover:border-white/[0.1]">
      <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">{label}</div>
      <div data-testid={testid} className={cn("num mt-1.5 text-xl font-semibold tracking-tight text-slate-50", className)}>{value}</div>
      {sub && <div className="mt-1 text-[11px] text-slate-500">{sub}</div>}
    </div>
  );
}

export function Banner({ tone = "info", children, testid }) {
  const t = { info: "border-sky-500/30 bg-sky-500/10 text-sky-200", warn: "border-amber-500/30 bg-amber-500/10 text-amber-200", error: "border-rose-500/30 bg-rose-500/10 text-rose-200", ok: "border-emerald-500/30 bg-emerald-500/10 text-emerald-200" };
  return <div data-testid={testid} className={cn("rounded-lg border px-4 py-3 text-sm backdrop-blur-sm", t[tone])}>{children}</div>;
}

export const Th = ({ children, className }) => <th className={cn("bg-[#0A0E16]/60 px-3.5 py-2.5 text-left text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400 whitespace-nowrap", className)}>{children}</th>;
export const Td = ({ children, className, ...p }) => <td {...p} className={cn("px-3.5 py-2.5 text-sm text-slate-200 whitespace-nowrap", className)}>{children}</td>;
